// extracted by mini-css-extract-plugin
export default {"page-content":"styles-module_page-content__rrBF0q","container":"styles-module_container__VMJeCG"};